<hx-form-group [class]="hostCssClasses()" [error]="showError()">
  <hx-label
    [description]="label()"
    [required]="required()"
    [for]="idInput()"
    [tooltip]="tooltip()"
    [tooltipPosition]="tooltipPosition()"
    [tooltipColor]="tooltipColor()"></hx-label>

  <div class="hx-masked-text__input-wrapper">
    <hx-input
      class="hx-masked-text__input"
      placeholder="Enter text"
      title="Text input field"
      type="text"
      [attr.aria-label]="label()"
      [attr.disabled]="disabled() ? true : null"
      [attr.placeholder]="watermark()"
      [attr.title]="label()"
      [disabled]="disabled()"
      [id]="idInput()"
      [required]="required()"
      [value]="displayValue()"
      (blur)="onBlur()"
      (copy)="onCopy($event)"
      (input)="onInput($event)" />
    <hx-icon
      class="hx-masked-text__toggle"
      [attr.aria-label]="isMasked() ? 'Show value' : 'Hide value'"
      [attr.role]="'button'"
      [attr.tabindex]="0"
      [svgIcon]="isMasked() ? 'eye' : 'eye-slash'"
      (click)="toggleMask()"
      (keydown.enter)="toggleMask()"
      (keydown.space)="toggleMask()" />
  </div>

  @if (softWarning()) {
    <div class="hx-masked-text__warning" hx-hint>{{ softWarning() }}</div>
  } @else if (helpText()) {
    <div hx-hint>{{ helpText() }}</div>
  }

  @if (showError()) {
    <div hx-error>{{ errorState() }}</div>
  }
</hx-form-group>
